import React, { useEffect, useState } from 'react';

const getUserDisplayName = (user) =>
  user.user_name || user.from_name || user.from_login || user.to_name || user.to_login || '';

const NameList = ({ users, electedUser }) => {
  const [reorderedUsers, setReorderedUsers] = useState(users);

  useEffect(() => {
    const reorderUsers = () => {
      const updatedUsers = [...users];
      const electedName = electedUser ? getUserDisplayName(electedUser).toLowerCase() : '';
      const electedIndex = updatedUsers.findIndex(
        user => getUserDisplayName(user).toLowerCase() === electedName
      );
      if (electedIndex !== -1) {
        const [elected] = updatedUsers.splice(electedIndex, 1);
        updatedUsers.unshift(elected);
      }
      return updatedUsers;
    };

    setReorderedUsers(reorderUsers());
  }, [electedUser, users]);

  return (
    <div className="out-users-box">
      <div className="users-box">
        <ul>
          {reorderedUsers.map((user, index) => {
            const displayName = getUserDisplayName(user);
            const isSelected =
              electedUser &&
              displayName.toLowerCase() === getUserDisplayName(electedUser).toLowerCase();

            return (
              <li
                className={`user-list${isSelected ? ' selected-user' : ''}`}
                key={user.user_id || user.from_id || user.to_id || index}
              >
                {displayName}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default NameList;
